<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <div class="filter-descriptions" />
</template>

<script>

/**
 * Vue: Filter descriptions (filter-descriptions)
 * -----------------------------------------------------------------------------
 * Add descriptions for Boost filter facets.
 * - Limited interactivity section.
 *
 * @param {Object} filters - filter data.
 *
 */
export default {
  name: 'FilterDescriptions',

  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },

  mounted() {
    window.filters = this.filters
  },
}
</script>
